"use client";

import { ArrowLeft } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
export default function Destinations() {
  const services = [{
    title: "Pacote Peru",
    category: "Pacote Internacional",
    description: "Explore as maravilhas de Machu Picchu e a rica cultura andina com total conforto e segurança.",
    link: "https://www.kgviagens.com/pacote-peru-lima-cusco-machu-picchu-montanha-colorida/",
    subtitle: "Machu Picchu & Cusco",
    duration: "7 dias / 6 noites",
    price: "5.530",
    image: "https://www.kgviagens.com/wp-content/uploads/2026/06/machu-picchu-cidade-perdida-incas-peru-1.webp-1.webp?v=m8dqmh5kolr",
    button_label: "Conhecer Roteiro",
    departure_city: "Lima (Peru)",
    hotel_passeios: "Hospedagem + Passeios + Trem"
  }, {
    title: "Pacote Marrocos",
    category: "Pacote Internacional",
    description: "Uma jornada sensorial pelos desertos, mercados vibrantes e palácios imperiais marroquinos.",
    link: "https://www.kgviagens.com/marrocos-deserto-saara-marrakech/",
    subtitle: 'Casablanca & Sahara',
    price: "8.911",
    image: 'https://www.kgviagens.com/wp-content/uploads/2026/10/marrocos-card-otimizada.webp',
    imageWidth: 640,
    imageHeight: 853,
    duration: "8 dias / 7 noites",
    departure_city: "Casablanca (Marrocos)",
    button_label: "Conhecer Roteiro",
    hotel_passeios: "Deserto + Cidades Imperiais"
  }, {
    title: "Lençóis Maranhenses",
    category: "Pacote Nacional",
    description: "Descubra o paraíso das dunas e lagoas cristalinas no coração do Nordeste brasileiro.",
    link: "https://www.kgviagens.com/lencois-maranhenses-santo-amaro-barreirinhas/",
    subtitle: 'Dunas & Lagoas',
    price: "4.079",
    image: 'https://www.kgviagens.com/wp-content/uploads/2026/10/lencois-maranhenses-card-otimizada.webp',
    imageWidth: 640,
    imageHeight: 480,
    duration: "5 dias / 4 noites",
    departure_city: "São Luís (MA)",
    button_label: "Conhecer Roteiro",
    hotel_passeios: "Lagoas + Pôr do Sol"
  }, {
    title: "Nova York com Washington",
    category: "Pacote Internacional",
    description: "O melhor da cultura, história e sofisticação das duas principais metrópoles americanas.",
    link: 'https://www.kgviagens.com/pacote-nova-york-com-washington-nos-estados-unidos/',
    subtitle: 'Metrópoles Americanas',
    price: "9.082",
    image: 'https://www.kgviagens.com/wp-content/uploads/2026/10/nova-york-card-otimizada.webp',
    duration: "7 dias / 6 noites",
    departure_city: "Nova York (EUA)",
    button_label: "Conhecer Roteiro",
    hotel_passeios: "City Tour + Washington"
  }, {
    title: "Argentina, Bariloche e Chile",
    category: "Pacote América do Sul",
    description: "Uma travessia inesquecível pelos lagos andinos e as paisagens deslumbrantes da Patagônia.",
    link: 'https://www.kgviagens.com/argentina-bariloche-chile-patagonia-andes/',
    subtitle: 'Patagônia & Lagos',
    price: "3.779",
    image: 'https://www.kgviagens.com/wp-content/uploads/2026/10/argentina-bariloche-chile-card-otimizada.webp',
    imageWidth: 640,
    imageHeight: 480,
    duration: "10 dias / 9 noites",
    departure_city: "Buenos Aires (AR)",
    button_label: "Conhecer Roteiro",
    hotel_passeios: "Bariloche + Lagos Andinos"
  }, {
    title: "Londres, Irlanda e Edimburgo",
    category: "Pacote Europa",
    description: "Roteiro clássico pelas capitais britânicas, unindo história, castelos e elegância europeia.",
    link: 'https://www.kgviagens.com/pacote-londres-kg-viagens/',
    subtitle: 'Capitais Britânicas',
    price: "7.490",
    image: 'https://www.kgviagens.com/wp-content/uploads/2026/06/kg-viagens-tower-bridge-londres.webp?v=g1jbu1196le',
    duration: "7 dias / 6 noites",
    departure_city: "Londres\xA0",
    button_label: "Conhecer Roteiro",
    hotel_passeios: "Castelos + Cultura Britânica"
  }];
  return <section data-section-id="20983" id="populardestinationsgrid" dir="ltr" className="bg-background text-foreground py-32 md:py-44 px-6 md:px-24">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end">
          <div className="lg:col-span-5 lg:order-2">
            <p className="font-default text-lg md:text-xl leading-[1.55] max-w-[44ch] text-secondary" style={{
            color: "var(--muted-foreground)"
          }}>Na KG VIAGENS, transformamos o seu desejo de explorar o mundo em realidade. Experiências exclusivas e roteiros personalizados para pessoas que buscam o extraordinário com segurança e conforto.&nbsp;</p>
            <div className="mt-8">
              <Link to="#" className="inline-flex items-center gap-2 font-default text-base group" style={{
              color: "var(--foreground)"
            }}>
                <span className="relative">
                  Conheça nossos pacotes
                  <span className="absolute left-0 -bottom-1 h-px w-full transition-all duration-200 group-hover:h-0.5" style={{
                  background: "var(--primary)"
                }} />
                </span>
                <ArrowLeft className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>

          <div className="lg:col-span-7 lg:order-1">
            <h2 className="font-serif font-default leading-[0.9] tracking-[-0.035em] text-[#3E9894]" style={{
            fontSize: "clamp(3rem, 8.5vw, 7.5rem)",
            fontWeight: 680
          }}>Destinos Selecionados</h2>
          </div>
        </div>

        <div className="mt-24 md:mt-32 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {services.map((service, i) => {
          return <div key={i} data-index={i} className="group relative bg-white flex flex-col h-full rounded-lg overflow-hidden shadow-md">
                <div className="relative">
                  <img src={service.image} width={service.imageWidth} height={service.imageHeight} data-wvc-srcset={`${service.image}-wvc-srcset`} data-wvc-sizes={`${service.image}-wvc-sizes`} alt={service.title} loading="lazy" data-editable="image" className="w-full aspect-[4/3] object-cover mb-0" />
                  {service.duration && <Badge data-editable="duration" className="absolute bottom-3 left-3 bg-black/60 text-white border-none rounded-lg backdrop-blur-sm">
                      {service.duration}
                    </Badge>}
                </div>
                
                <div className="px-4 md:px-6 py-4 md:py-5 flex flex-col flex-grow">
                  <h3 className="font-serif text-xl md:text-2xl mb-1 leading-[1.05] tracking-[-0.02em]" style={{
                fontWeight: 600
              }}>
                    <span className="relative inline-block">
                      {service.title}
                      <span className="absolute left-0 bottom-0 h-px w-0 group-hover:w-full transition-all duration-[320ms] ease-out" style={{
                    background: "var(--primary)"
                  }} />
                    </span>
                  </h3>

                  <p className="text-sm text-muted-foreground mb-1" data-editable="departure_city">
                     Início em: {service.departure_city}
                  </p>

                  <p className="text-sm text-muted-foreground mb-3" data-editable="hotel_passeios">
                     {service.hotel_passeios}
                  </p>

                  {service.price && <p className="text-lg font-bold mb-4" style={{
                color: "#B35900"
              }} data-editable="price">
                      A partir de R$ {service.price}
                    </p>}

                  <div className="mt-auto">
                    <Button asChild className="w-full bg-[#AF560E] hover:bg-[#8E460B] text-white rounded-lg">
                      <Link to={service.link} data-editable="button_link">
                        {service.button_label || 'Ver roteiro'}
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}